/**
 * 状态机定义 - 对齐 PRD 05 §3
 * 每个状态机提供：合法转换表 + 终态集合 + 守卫函数。
 *
 * 所有状态变更必须经过守卫函数校验，禁止直接改 status 字段。
 */
import { OrderStatus, ORDER_TERMINAL_STATES, SettlementStatus, InvoiceStatus, InvoiceCategory, } from './enums.js';
// ============ 订单状态机（2 态：PAID → REFUNDED） ============
const ORDER_TRANSITIONS = {
    [OrderStatus.PAID]: [OrderStatus.REFUNDED],
    [OrderStatus.REFUNDED]: [],
};
/** 校验订单状态转换是否合法 */
export function canTransitionOrder(from, to) {
    if (ORDER_TERMINAL_STATES.has(from))
        return false;
    return ORDER_TRANSITIONS[from].includes(to);
}
/** 断言订单状态转换合法，否则抛错 */
export function assertOrderTransition(from, to) {
    if (!canTransitionOrder(from, to)) {
        throw new Error(`非法订单状态转换: ${from} → ${to}`);
    }
}
// ============ 分账状态机（PRD 05 §3.2） ============
const SETTLEMENT_TRANSITIONS = {
    [SettlementStatus.PENDING]: [SettlementStatus.EXECUTING],
    [SettlementStatus.EXECUTING]: [SettlementStatus.SUCCESS, SettlementStatus.FAILED],
    [SettlementStatus.SUCCESS]: [SettlementStatus.REVERSING],
    [SettlementStatus.FAILED]: [], // 失败后由重试逻辑或人工处理，不再走自动转换
    [SettlementStatus.REVERSING]: [SettlementStatus.REVERSED],
    [SettlementStatus.REVERSED]: [],
};
export function canTransitionSettlement(from, to) {
    return SETTLEMENT_TRANSITIONS[from].includes(to);
}
export function assertSettlementTransition(from, to) {
    if (!canTransitionSettlement(from, to)) {
        throw new Error(`非法分账状态转换: ${from} → ${to}`);
    }
}
// ============ 发票状态机（PRD 05 §3.3，双票各走一套） ============
const INVOICE_TRANSITIONS = {
    [InvoiceStatus.NOT_ISSUED]: [InvoiceStatus.ISSUING],
    [InvoiceStatus.ISSUING]: [InvoiceStatus.ISSUED, InvoiceStatus.FAILED],
    [InvoiceStatus.ISSUED]: [InvoiceStatus.RED_FLUSHING],
    [InvoiceStatus.FAILED]: [InvoiceStatus.ISSUING], // 可重试
    [InvoiceStatus.RED_FLUSHING]: [InvoiceStatus.RED_FLUSHED],
    [InvoiceStatus.RED_FLUSHED]: [],
};
export function canTransitionInvoice(from, to) {
    return INVOICE_TRANSITIONS[from].includes(to);
}
export function assertInvoiceTransition(from, to) {
    if (!canTransitionInvoice(from, to)) {
        throw new Error(`非法发票状态转换: ${from} → ${to}`);
    }
}
/**
 * 校验发票 issuer 与 category 的一致性（双票核心不变量）
 * - GOODS 票 issuer 必须是工厂
 * - SERVICE_FEE 票 issuer 必须是商家
 */
export function assertInvoiceIssuerCategory(issuerRole, category) {
    const ok = (category === InvoiceCategory.GOODS && issuerRole === 'FACTORY') ||
        (category === InvoiceCategory.SERVICE_FEE && issuerRole === 'SELLER');
    if (!ok) {
        throw new Error(`发票 issuer/category 不一致: issuer=${issuerRole}, category=${category}（GOODS 须工厂, SERVICE_FEE 须商家）`);
    }
}
//# sourceMappingURL=states.js.map